import { useTranslation } from 'react-i18next'

import { FileMultiValue } from '../../File'
import { FloatingTooltip } from '../../Floating'
import { TableCellBase, TableCellInfo, TableEmptyCell } from '../../Table'
import { DOC_FLOW_FILE_ADDITIONAL_INFO_TOOLTIP } from '../DocFlow.constants'

import * as styles from './DocFlowTableRowFile.module.css'

function DocFlowTableRowFile({
  info,
  infoTooltip,
  item,
  tooltip,
  tooltipPosition,
  onClickFile,
  ...restProps
}) {
  const { t } = useTranslation()

  return item ? (
    <TableCellBase {...restProps}>
      <FileMultiValue
        showTooltip
        additionalTooltipInfo={t(DOC_FLOW_FILE_ADDITIONAL_INFO_TOOLTIP)}
        item={item}
        onClick={onClickFile}
      />
      {info ? (
        <TableCellInfo className={styles.info} value={t(infoTooltip)} />
      ) : null}
    </TableCellBase>
  ) : (
    <FloatingTooltip
      content={tooltip}
      disabled={!tooltip}
      placement={tooltipPosition}
    >
      <TableEmptyCell {...restProps} />
    </FloatingTooltip>
  )
}

export default DocFlowTableRowFile
